import React, { Component } from 'react';
import {
    RowIndex as Index,
    ExerciseIconWrapper as IconWrapper,
    ExerciseIcon,
    ExerciseNameColumn,
    ExerciseRow,
    ExerciseRowSide,
    ExerciseRowRightSide,
    ExerciseRowItem as Item,
    Row,
    ActionIconItem,
    ExerciseActionsRow,
    KebabMenuContainer,
} from './style';
import { config } from '../../../../Configurations';
import { Text, BoldText } from '../../../UI/Text';
import { getNumberOrder, selectInputContentOnFocus } from '../../../../Utils';
import { Icon } from '../../../Components/Icons/Icons';
import { Input } from '../../../Components/Inputs/InputContainer';
import { WorkoutPlanExercisesKebab } from '../../../Components/Dropdowns';
import { OuterMargin } from '../../../Layouts';
import DurationPicker from '../../../Components/Pickers/TimePicker';

export class AddedExercise extends Component {
    constructor(props) {
        super(props);

        this.state = {
            speed: 'N/A',
        };
    }

    deleteExercise = () => {
        const { index, actions, roundIndex } = this.props;
        actions.deleteExercise(roundIndex, index);
    };

    duplicateExercise = () => {
        const { index, actions, roundIndex } = this.props;
        actions.duplicateExercise(roundIndex, index);
    };

    moveExerciseUp = () => {
        const { index, actions, roundIndex } = this.props;
        actions.moveExerciseUp(roundIndex, index);
    };

    moveExerciseDown = () => {
        const { index, actions, roundIndex } = this.props;
        actions.moveExerciseDown(roundIndex, index);
    };

    editExerciseValue = e => {
        const { index, actions, roundIndex } = this.props;
        actions.editExerciseValue(roundIndex, index, e);
    };

    timeEdit = duration => {
        const { index, actions, roundIndex } = this.props;

        const _duration = duration;
        actions.editExerciseValue(roundIndex, index, null, _duration);
    };

    render() {
        const {
            props: { id, index, name, whiteImage, kgs, distance, reps, time, speed, setNumber, ...exercise },
            deleteExercise,
            duplicateExercise,
            moveExerciseDown,
            moveExerciseUp,
            editExerciseValue,
            timeEdit,
        } = this;
        const image = `${config.baseUrl}/${whiteImage}`;

        return (
            <ExerciseRow>
                <ExerciseRowSide>
                    <Index>{index + 1}</Index>

                    <IconWrapper>
                        <ExerciseIcon img={image} />
                    </IconWrapper>

                    <ExerciseNameColumn>
                        <BoldText marginBottom={'5px'}>{name}</BoldText>
                        {id !== 276 && (
                            <Text opacity={0.5} weight={300} fontSize={12}>
                                {getNumberOrder(setNumber)} set
                            </Text>
                        )}
                    </ExerciseNameColumn>
                </ExerciseRowSide>

                {/* Exercise data inputs */}
                <ExerciseRowRightSide>
                    <Row>
                        <Input>
                            <SelectOnFocusInput
                                disabled={!exercise.isDistanceRequired}
                                onChange={editExerciseValue}
                                name={'speed'}
                                value={speed || 'N/A'}
                            />
                        </Input>

                        <Input>
                            <SelectOnFocusInput
                                disabled={!exercise.isDistanceRequired}
                                onChange={editExerciseValue}
                                name={'distance'}
                                value={distance}
                            />
                        </Input>

                        <OuterMargin right={'20px'}>
                            <DurationPicker initial={time} passData={timeEdit} />
                        </OuterMargin>

                        <Input>
                            <SelectOnFocusInput value={kgs} name={'kgs'} onChange={editExerciseValue} />
                        </Input>

                        <Input>
                            <SelectOnFocusInput
                                disabled={exercise.isDistanceRequired}
                                value={reps}
                                name={'reps'}
                                onChange={editExerciseValue}
                            />
                        </Input>
                    </Row>

                    {/* Exercise actions */}
                    <ExerciseActionsRow>
                        <ActionIconItem onClick={deleteExercise}>
                            <Icon.Box size={'18x18'}>
                                <Icon.Delete />
                            </Icon.Box>
                        </ActionIconItem>

                        <ActionIconItem onClick={duplicateExercise}>
                            <Icon.Box size={'18x18'}>
                                <Icon.Copy />
                            </Icon.Box>
                        </ActionIconItem>

                        <ActionIconItem onClick={moveExerciseUp}>
                            <Icon.Box size={'18x18'}>
                                <Icon.ArrowUp />
                            </Icon.Box>
                        </ActionIconItem>

                        <ActionIconItem onClick={moveExerciseDown}>
                            <Icon.Box size={'18x18'}>
                                <Icon.ArrowDown />
                            </Icon.Box>
                        </ActionIconItem>
                    </ExerciseActionsRow>

                    <KebabMenuContainer>
                        <WorkoutPlanExercisesKebab
                            onDelete={deleteExercise}
                            onDuplicate={duplicateExercise}
                            onMoveUp={moveExerciseUp}
                            onMoveDown={moveExerciseDown}
                        />
                    </KebabMenuContainer>
                </ExerciseRowRightSide>
            </ExerciseRow>
        );
    }
}

const SelectOnFocusInput = props => <Item onFocus={selectInputContentOnFocus} autoComplete={'off'} {...props} />;



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/AddedExercise.js